import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=4239c150&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=4239c150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239c150",
  null
  
)

export default component.exports